/**
 * fakeApi.js
 *
 * This is the ONLY file that simulates a backend.
 * A real backend would return exactly this shape of JSON after a
 * successful login call. Nothing else in the app is allowed to know
 * how this data is produced — it's just "the response".
 */
const FAKE_LATENCY_MS = 400;

/**
 * Modules that exist in every system regardless of business type.
 * Add/remove here once and it propagates to all systems automatically.
 */
const COMMON_MODULES = ["profile", "parametre", "forum", "messages", "support","tools"];

/**
 * Each fake account maps 1:1 to a "system" the ERP can boot into.
 * Swapping/adding an account here is enough to introduce a brand new
 * system to the whole application — no component changes needed.
 */
const FAKE_ACCOUNTS = {
  "doctor@demo.com": {
    token: "fake-token-doctor-001",
    //user: { id: 1, name: "Dr. Ahmed" },
    system: {
      id: "docteur",
      title: "Doctor ERP",
      //layout: "medical",
      theme: { primary: "#1c6656", dark: false },
      language: "fr",
      modules: [
        "acceuil",
        "demmandes",
        "seances_docteur",
        "ordonance",
        "rapport",
        "client",
        "equipe",
        "finance",
        "tools"
      ],
    },
    user_data : {"PK":1,"PID":1020114134,"Activated":"true","Country":"TN","Genre":"UROLOGIE","Gouv":"SFAX","Deleg":"SFAX MEDINA","Localite":null,"CodeP":0,"Name":"MOHAMED TRIFA","Adress":"RUE M'HAMED CHAABOOUNI OLFA PLACE ESC G SFAX","Lat":"","Lng":"","Experience":"غير محدد","ProfilePhoto":"docteur_1020114134_0.jpg1755349720173-4944153869701.jpeg","Phone":0,"Views_Num":268,"Likes_Num":0,"Rating_Resume":"","SP_Tarif":"[{\"PK\":1,\"Name\":\"\",\"Qte\":\"\",\"Forfait\":\"Séance a domicile\",\"Prix\":\"85\",\"Description\":\"Rien\"},{\"PK\":1,\"Name\":\"\",\"Qte\":\"\",\"Forfait\":\"Seance A bureaux \",\"Prix\":\"75\",\"Description\":\"Seance de deux heurs\"}]","SP_Assurance":"","SP_Diplomes":"[{\"PK\":1,\"diplome\":\"Diplome nationale de medcine\",\"annee\":\"2005-02-15\",\"faculte\":\"Faculte de scien sousse \"},{\"PK\":1,\"diplome\":\"Dilome de sante Generale \",\"annee\":\"2015-05-20\",\"faculte\":\"Harvard Departemment \"}]"}
  },
  "autoecole@demo.com": {
    token: "fake-token-taxi-004",
    user: { id: 4, name: "Karim" },
    system: {
      id: "autoecole",
      title: "AutoEcole ERP",
      layout: "fleet",
      theme: { primary: "#07c7ce", dark: false },
      language: "ar",
      modules: [
        "acceuil",
        "demmandes",
        "abonnement_autoecole",
        "seances_autoecole",
        "client",
        "voiture_autoecole",
        "equipe",
        "finance",
      ],
       },
      user_data : {"PK":1,"PID":1023847779,"Activated":"","Country":"TN","Genre":"صنف ب","Gouv":"Tunis","Deleg":"Le Kram","Localite":"","SearchK":"","Name":"auto ecole WD","Adress":"5 avenue el jahed aeroport le kram - El kram Tunis","Lat":"","Lng":"","Phone":"98290695","ProfilePhoto":"","Plan":{"type":"Buffer","data":[]},"Views_Num":85,"Likes_Num":0,"Rating_Resume":"","SP_Tarif":"","SP_Voitures":"","SP_Trajets":"","SP_Team":""}
  },
  "gym@demo.com": {
    token: "fake-token-doctor-001",
    user: { id: 1, name: "Dr. Ahmed" },
    system: {
      id: "gym",
      title: "Gym ERP",
      layout: "medical",
      theme: { primary: "#354b46", dark: false },
      language: "fr",
      modules: [
        "acceuil",
        "demmandes",
        "abonnement_gym",
        "seances_gym",
        "client",
        "equipemment",
        "equipe",
        "finance",
      ],
    },
    user_data : {"PK":1,"PID":1267449596,"Activated":"true","Country":"TN","Genre":"GYM","Gouv":"Tunis","Deleg":"Le Marsa","Localite":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","SearchK":"","Name":"Benkay Sushi","Adress":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","Lat":"","Lng":"","Phone":"29 209 902","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":48,"Likes_Num":0,"Rating_Resume":"","SP_Teams":"","SP_Tarif":"","SP_Tools":"","SP_Coach":""}
  },
  "restaurant@demo.com": {
    token: "fake-token-restaurant-003",
    user: { id: 3, name: "Marco" },
    system: {
      id: "restaurant",
      title: "Restaurant ERP",
      layout: "hospitality",
      theme: { primary: "#E53935", dark: false },
      language: "it",
      modules: [
        "acceuil",
        "demmandes",
        "reservations",
        "menu",
        "caisses_restaurant",
        "facture_restaurant",
        "client",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":1,"PID":1567154730,"Activated":"true","Country":"TN","Genre":"PIZZA","Gouv":"Tunis","Deleg":"","Localite":"","SearchK":"","Name":"Piment rouge","Adress":"Centre Urbain Nord. Malek Centre ,CITE EL MAHRAJENE TUNIS - La medina Tuni","Lng":"10.1548032","Lat":"36.8115712","Phone":"23 446 119","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":250,"Likes_Num":1,"Rating_Resume":"","SP_Menu":"","SP_Tables":"","SP_Services":"","SP_Promotion":""}
    
  },
  "garderie@demo.com": {
    token: "fake-token-shop-002",
    user: { id: 2, name: "Sara" },
    system: {
      id: "garderie",
      title: "Garderie ERP",
      layout: "retail",
      theme: { primary: "#df148a", dark: false },
      language: "en",
      modules: [
        "acceuil",
        "demmandes",
        "eleves",
        "abonnement_garderie",
        "classes",
        "seances_garderie",
        "examen_garderie",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":1,"PID":1541044238,"Activated":"YES","Country":"TN","Genre":2,"Gouv":"Siliana","Deleg":"Sidi Bourouis","Localite":"Sidi bourouis","Name":"Garderie Abyedh","Adress":"Sidi bourouis siliana 6113","Lat":"","Lng":"","Tel":90909090,"Phone":"","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":null,"Directeur":"Houssem","Views_Num":10,"Likes_Num":0,"Rating_Resume":"","SP_Classes":"","SP_Tarif":"","SP_Emplois":"","SP_Examain":"","SP_Team":""}
    
  },
  "magazin@demo.com": {
    token: "fake-token-shop-002",
    user: { id: 2, name: "Sara" },
    system: {
      id: "magazin",
      title: "Magazin ERP",
      layout: "retail",
      theme: { primary: "#43A047", dark: false },
      language: "en",
      modules: [
        "acceuil",
        "demmandes",
        "stock",
        "facture_magazin",
        "caisses_magazin",
        "client",
        "fournisseur",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":205,"PID":9196453462,"Activated":"true","Country":"TN","Genre":"magazin","Gouv":"Siliana","Deleg":"Sidi Bourouis","Localite":"","Name":"Familia Market A\n","Adress":"Sidi Bou Rouis","SearchK":"","Phone":"78898254","Matricule_F":"","Lng":"9.124272376668385","Lat":"36.17723289443252","Views_Num":70,"Likes_Num":1,"Rating_Resume":"","SP_Articles":"","SP_Genres":"","SP_Promotion":""}
    
  },
  "trasnporteur@demo.com": {
    token: "fake-token-taxi-004",
    user: { id: 4, name: "Karim" },
    system: {
      id: "transporteur",
      title: "Transporteur ERP",
      layout: "fleet",
      theme: { primary: "#a54403", dark: false },
      language: "ar",
      modules: [
        "acceuil",
        "demmandes",
        "operations",
        "stock_transporteur",
        "camions",
        "client",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":2,"PID":5047651228,"Activated":"","Country":"TN","Genre":"Transporteur","Gouv":"Tunis","Deleg":"La Goulette","Localite":null,"SearchK":"","Name":"BAIEXPRESS","Adress":"24 rue abdelaziz thaalbi Tunisie, La Goulette 2060","Lng":"10.308861019221917","Lat":"36.83328668727827","Phone":"29763251","Views_Num":113,"Likes_Num":1,"Rating_Resume":"","SP_Tarif":"","SP_Camions":"","SP_Trips":""}
    
  },
  "avocat@demo.com": {
    token: "fake-token-restaurant-003",
    user: { id: 3, name: "Marco" },
    system: {
      id: "avocat",
      title: "Avocat ERP",
      layout: "hospitality",
      theme: { primary: "#4b4a4a", dark: false },
      language: "it",
      modules: [
        "acceuil",
        "demmandes",
        "sujet",
        "seance_avocat",
        "client",
        "rapport",
        "equipe",
        "finance",
      ],
       },
      user_data : {"PK":1,"PID":1151543575,"Activated":"","Country":"TN","Genre":"","Gouv":"Tunis","Deleg":"","Localite":null,"SearchK":"","Name":"ATEF BELKAMEL","Adress":"16 Av. Mohamed V. Imm. Sahara confort. 1er étage. B3. Kheireddine. Le Kram. Tunis - El kram Tunis","Lat":"","Lng":"","Phone":"71721777","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":16,"Likes_Num":0,"Rating_Resume":"","SP_Tarif":"","SP_Promotion":"","SP_Diplomes":""}
   
  },
  "depot@demo.com": {
    token: "fake-token-taxi-004",
    user: { id: 4, name: "Karim" },
    system: {
      id: "depot",
      title: "Depot ERP",
      layout: "fleet",
      theme: { primary: "#4d4d4d", dark: false },
      language: "ar",
      modules: [
        "acceuil",
        "demmandes",
        "stock",
        "facture_magazin",
        "camions",
        "client",
        "fournisseur",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":217,"PID":1048400806,"Activated":"autoSaved","Country":"TN","Genre":"مَوَادْ غذائية","Gouv":"Kairouan","Deleg":"Kairouan Nord","Localite":"","Name":"El amendis distribution","Adress":"Baten","E_Adress":"","Phone":"58111151","Matricule_F":"","SearchK":"","Lng":"10.041010380446098","Lat":"35.696441286399676","Views_Num":4,"Likes_Num":0,"Rating_Resume":"","SP_Articles":"","SP_Genres":"","SP_Promotion":"","ProfilePhoto":""}
    
  },
  "hotels@demo.com": {
    token: "fake-token-restaurant-003",
    user: { id: 3, name: "Marco" },
    system: {
      id: "hotels",
      title: "Hotel ERP",
      layout: "hospitality",
      theme: { primary: "#247cc7", dark: false },
      language: "it",
      modules: [
        "acceuil",
        "demmandes",
        "reservations",
        "chambres",
        "service",
        "client",
        "equipe",
        "finance",
      ],
       },
      user_data : {"PK":1,"PID":1267449596,"Activated":"true","Country":"TN","Genre":"GYM","Gouv":"Tunis","Deleg":"Le Marsa","Localite":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","SearchK":"","Name":"Benkay Sushi","Adress":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","Lat":"","Lng":"","Phone":"29 209 902","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":48,"Likes_Num":0,"Rating_Resume":"","SP_Teams":"","SP_Tarif":"","SP_Tools":"","SP_Coach":""}
  },
  "vg_agence@demo.com": {
    token: "fake-token-restaurant-003",
    user: { id: 3, name: "Marco" },
    system: {
      id: "vg_agence",
      title: "vg_agence ERP",
      layout: "hospitality",
      theme: { primary: "#ce8c64", dark: false },
      language: "it",
      modules: [
        "acceuil",
      "demmandes",
      "reservations",
      "voyages",
      "partenaires",
      "client",
      "equipe",
      "finance",
      ],
       },
      user_data : {"PK":1,"PID":1267449596,"Activated":"true","Country":"TN","Genre":"GYM","Gouv":"Tunis","Deleg":"Le Marsa","Localite":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","SearchK":"","Name":"Benkay Sushi","Adress":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","Lat":"","Lng":"","Phone":"29 209 902","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":48,"Likes_Num":0,"Rating_Resume":"","SP_Teams":"","SP_Tarif":"","SP_Tools":"","SP_Coach":""}
  },
  "location@demo.com": {
    token: "fake-token-restaurant-003",
    user: { id: 3, name: "Marco" },
    system: {
      id: "location",
      title: "Location ERP",
      layout: "hospitality",
      theme: { primary: "#4b4a4a", dark: false },
      language: "it",
      modules: [
        "acceuil",
        "demmandes",
        "reservations",
        "locations",
        "voiture_autoecole",
        "client",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":1,"PID":1267449596,"Activated":"true","Country":"TN","Genre":"GYM","Gouv":"Tunis","Deleg":"Le Marsa","Localite":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","SearchK":"","Name":"Benkay Sushi","Adress":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","Lat":"","Lng":"","Phone":"29 209 902","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":48,"Likes_Num":0,"Rating_Resume":"","SP_Teams":"","SP_Tarif":"","SP_Tools":"","SP_Coach":""}

    
  },
  "labo@demo.com": {
    token: "fake-token-restaurant-003",
    user: { id: 3, name: "Marco" },
    system: {
      id: "labo",
      title: "Labo ERP",
      layout: "hospitality",
      theme: { primary: "#1dd3b0", dark: false },
      language: "it",
      modules: [
       "acceuil",
        "demmandes",
        "analyses",
        "rapport",
        "client",
        "equipe",
        "finance",
      ],
      },
      user_data : {"PK":1,"PID":1267449596,"Activated":"true","Country":"TN","Genre":"GYM","Gouv":"Tunis","Deleg":"Le Marsa","Localite":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","SearchK":"","Name":"Benkay Sushi","Adress":"8 avenue Ali belhaouen La Marsa - La marsa Tunis","Lat":"","Lng":"","Phone":"29 209 902","ProfilePhoto":{"type":"Buffer","data":[]},"Plan":{"type":"Buffer","data":[]},"Views_Num":48,"Likes_Num":0,"Rating_Resume":"","SP_Teams":"","SP_Tarif":"","SP_Tools":"","SP_Coach":""}
  },
  "infirmier@demo.com": {
    token: "fake-token-doctor-001",
    //user: { id: 1, name: "Dr. Ahmed" },
    system: {
      id: "docteur",
      title: "Infirmier ERP",
      //layout: "medical",
      theme: { primary: "#1c6656", dark: false },
      language: "fr",
      modules: [
        "acceuil",
        "demmandes",
        "seances_docteur",
        "ordonance",
        "abonnement_autoecole",
        "seances_autoecole",
        "voiture_autoecole",
        "abonnement_gym",
        "seances_gym",
        "rapport",
        "client",
        "equipe",
        "finance",
        "tools"
      ],
    },
    user_data : {"PK":1,"PID":1020114134,"Activated":"true","Country":"TN","Genre":"UROLOGIE","Gouv":"SFAX","Deleg":"SFAX MEDINA","Localite":null,"CodeP":0,"Name":"MOHAMED TRIFA","Adress":"RUE M'HAMED CHAABOOUNI OLFA PLACE ESC G SFAX","Lat":"","Lng":"","Experience":"غير محدد","ProfilePhoto":"docteur_1020114134_0.jpg1755349720173-4944153869701.jpeg","Phone":0,"Views_Num":268,"Likes_Num":0,"Rating_Resume":"","SP_Tarif":"[{\"PK\":1,\"Name\":\"\",\"Qte\":\"\",\"Forfait\":\"Séance a domicile\",\"Prix\":\"85\",\"Description\":\"Rien\"},{\"PK\":1,\"Name\":\"\",\"Qte\":\"\",\"Forfait\":\"Seance A bureaux \",\"Prix\":\"75\",\"Description\":\"Seance de deux heurs\"}]","SP_Assurance":"","SP_Diplomes":"[{\"PK\":1,\"diplome\":\"Diplome nationale de medcine\",\"annee\":\"2005-02-15\",\"faculte\":\"Faculte de scien sousse \"},{\"PK\":1,\"diplome\":\"Dilome de sante Generale \",\"annee\":\"2015-05-20\",\"faculte\":\"Harvard Departemment \"}]"}
  },
};

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Merges an account's specific modules with the common ones that
 * every system must have, de-duplicating in case of overlap.
 */
function withCommonModules(system) {
  const merged = Array.from(new Set([...system.modules, ...COMMON_MODULES]));
  return { ...system, modules: merged };
}

/**
 * Simulates POST /auth/login
 * Any password is accepted for this demo; only the email selects
 * which fake account/system configuration is returned.
 */
export async function fakeLogin(email, _password) {
  await delay(FAKE_LATENCY_MS);
  const account = FAKE_ACCOUNTS[email];
  if (!account) {
    const error = new Error("Invalid credentials");
    error.code = "INVALID_CREDENTIALS";
    throw error;
  }

  const merged = {
    ...account,
    system: withCommonModules(account.system),
  };

  // Return a deep copy so nothing downstream can mutate the "server" data.
  return JSON.parse(JSON.stringify(merged));
}

export function listDemoAccounts() {
  return Object.entries(FAKE_ACCOUNTS).map(([email, payload]) => ({
    email,
    systemId: payload.system.id,
    title: payload.system.title,
  }));
}
